import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on }                               from '@ngrx/store';

import {
  addCampaign,
  CampaignAction,
  deleteCampaign,
  deleteEditorialPlanification,
  loadCampaigns, loadEditorialPlanifications, resetCampaigns,
  setActiveEditorialTimestamp,
  toggleCampaignStatus, updateCampaign
} from '../actions/campaign.actions';
import { NewsletterGlobalAction, resetNewsletter } from '../actions/newsletter.actions';

import { CampaignConfig, EditorialPlanification } from '../../../mediego-common-module/declarations/campaign-config';

export interface CampaignsState extends EntityState<CampaignConfig> {
  editorialPlanifications: EditorialPlanification[];
  activeEditorialTimestamp: number | null;
}

export const campaignsAdapter: EntityAdapter<CampaignConfig> = createEntityAdapter<CampaignConfig>({
  selectId: (__) => __.id.id
});

const INITIAL_STATE: CampaignsState = campaignsAdapter.getInitialState({
  editorialPlanifications: [],
  activeEditorialTimestamp: null
});

const reducer = createReducer(
  INITIAL_STATE,
  on(resetNewsletter, (_) => INITIAL_STATE),
  on(loadCampaigns, (state, { campaigns }) =>
    campaignsAdapter.setAll(campaigns, state)
  ),
  on(loadEditorialPlanifications, (state, { editorialPlanifications }) => ({
    ...state,
    editorialPlanifications
  })),
  on(addCampaign, (state, { campaign }) =>
    campaignsAdapter.addOne(campaign, state)
  ),
  on(deleteCampaign, (state, { id }) =>
    campaignsAdapter.removeOne(id, state)
  ),
  on(deleteEditorialPlanification, (state, { timestamp }) => ({
    ...state,
    editorialPlanifications: state.editorialPlanifications.filter(e => e.timestamp !== timestamp),
    activeEditorialTimestamp: state.activeEditorialTimestamp === timestamp ? null : state.activeEditorialTimestamp
  })),
  on(updateCampaign, (state, { id, partial }) =>
    campaignsAdapter.updateOne({
      id, changes: partial
    }, state)
  ),
  on(toggleCampaignStatus, (state, { id, status }) =>
    campaignsAdapter.updateOne({
      id, changes: { enabled: status }
    }, state)
  ),
  on(resetCampaigns, (_) =>
    INITIAL_STATE
  ),
  on(setActiveEditorialTimestamp, (state, { timestamp }) => ({
    ...state,
    activeEditorialTimestamp: timestamp
  }))
);

export function campaignsReducer(state: CampaignsState, action: CampaignAction | NewsletterGlobalAction): CampaignsState {
  return reducer(state, action);
}
